import { render, staticRenderFns } from "./RiskFactor.vue?vue&type=template&id=b255bcf0&scoped=true&"
import script from "./RiskFactor.vue?vue&type=script&lang=js&"
export * from "./RiskFactor.vue?vue&type=script&lang=js&"
import style0 from "./RiskFactor.vue?vue&type=style&index=0&id=b255bcf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b255bcf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
